import React from 'react';
import propTypes from 'prop-types';
import { C, Masks } from 'shared/helpers';

import Styles from './Table.module.scss';

export default function Table({ data, totalArea }) {
  const { Table, Row, Nothing, Total, Name } = Styles;
  const { number } = Masks;
  const productionUnit = 'Kg';
  return (
    <div className={Table}>
      <header>
        <div>Produto</div>
        <div>Dose Total</div>
        <div>Total /ha</div>
        <div>Volume total de compra</div>
      </header>
      <main>
        {data.map(x => (
          <div className={Row}>
            <div id={`produto_${x.id || x._id}`} className={Name}>
              {x.nome}
            </div>
            <div id={`dose_total_${x.id || x._id}`}>
              {number(x.dose, { ed: 2, suffix: ` ${productionUnit}/ha` })}
            </div>
            <div id={`total_${x.id || x._id}`}>
              {number(totalArea, { ed: 2, suffix: ' /ha' })}
            </div>
            <div id={`volume_total_${x.id || x._id}`}>
              {number(x.dose * totalArea, {
                ed: 2,
                suffix: ` ${productionUnit}`,
              })}
            </div>
          </div>
        ))}
        <div className={C(Row, Total)}>
          <div>TOTAL</div>
          <div id='dose_total_total'>
            {number(
              data.map(x => x.dose),
              { ed: 2, suffix: ` ${productionUnit}/ha` },
            )}
          </div>
          <div className={Nothing} />
          <div id='volume_total_total'>
            {number(
              data.map(x => Number(x.dose) * Number(totalArea)),
              { ed: 2, suffix: ` ${productionUnit}/ha` },
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

Table.defaultProps = {
  totalArea: 0,
};

Table.propTypes = {
  data: propTypes.any.isRequired,
  totalArea: propTypes.number,
};
